import { render, staticRenderFns } from "./FaceCheckbox.vue?vue&type=template&id=1d97e5f5&scoped=true&lang=pug&"
import script from "./FaceCheckbox.vue?vue&type=script&lang=ts&"
export * from "./FaceCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./FaceCheckbox.vue?vue&type=style&index=0&id=1d97e5f5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d97e5f5",
  null
  
)

export default component.exports